import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className }) => (
  <span className="block overflow-hidden pb-2 -mb-2">
    <motion.span
      className={`block ${className || ""}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.05, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Overline = ({ children, light = false }) => (
  <p
    className={`flex items-center gap-3 text-sm font-bold tracking-[0.24em] uppercase ${
      light ? "justify-center text-sand/70" : "text-[#8a6a4e]"
    }`}
  >
    <span
      className={`h-[2px] w-8 shrink-0 rounded-full ${light ? "bg-sand/50" : "bg-clay"}`}
      aria-hidden="true"
    />
    {children}
  </p>
);
